export const CHANGE_SERVICE_VERSION = 'CHANGE_SERVICE_VERSION';
